/**
 * Routers used for pages with only a log
 **/
import Backbone from 'backbone';
import MemberLogView from './components/log-member/view';
import AdminLogView from './components/log-admin/view';
import TradeReportsLogView from './components/log-tradereports/view';
import UrgentNotificationsLogView from './components/log-urgent-notifications/view';

export default Backbone.Router.extend({
	views: {},

	routes: {
		'memberlog': 'memberLog',
		'tradereports': 'tradeReports',
		'delayednotifications': 'tradeReports',
		'administratorlog': 'administratorLog',
		'urgentnotifications': 'urgentNotifications'
	},

	// member log page
	memberLog: function() {
		this.view = new MemberLogView({
			el: '.js-log'
		});
	},

	// trade reports overview
	tradeReports: function() {
		this.view = new TradeReportsLogView({
			el: '.js-log'
		});
	},

	// log with urgent notifications
	urgentNotifications: function() {
		this.view = new UrgentNotificationsLogView({
			el: '.js-log'
		});
	},

	// log page, include filters
	administratorLog: function() {
		this.view = new AdminLogView({
			el: '.js-log'
		});
	}
});
